import { Injectable } from '@angular/core';
import { Observable, catchError, map, of, tap } from 'rxjs';
import { ProbabilityOfFailureItem } from '../types/risk-config.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProbabilityOfFailureService {
  private probabilityOfFailureItems: ProbabilityOfFailureItem[] = [];
  private cache: Map<string, ProbabilityOfFailureItem[]> = new Map();
  private dataLoaded: boolean = false;

  constructor(private http: HttpClient) { }

  private readonly url = `${environment.API_INSPEC}ProbabilityOfFailure`

  getProbabilityOfFailureItems(customerId: string): Observable<ProbabilityOfFailureItem[]> {
    // TODO - Make a better caching
    // if (this.dataLoaded) {
    //   const filteredItems = this.probabilityOfFailureItems.filter(item => item.customerId === customerId);
    //   if (filteredItems.length > 0) {
    //     return of(filteredItems);
    //   }
    // }

    return this.fetchItemsFromServer(customerId);
  }

  private fetchItemsFromServer(customerId: string): Observable<ProbabilityOfFailureItem[]> {
    return this.http.get<ProbabilityOfFailureItem[]>(`${this.url}/GetProbabilityOfFailureItems?customerId=${customerId}`).pipe(
      map(items => items.map(item => ({ ...item, type: 'probability' } as ProbabilityOfFailureItem))),
      map(items => items.sort((a, b) => b.order - a.order)),
      tap(items => {
        this.probabilityOfFailureItems = [...this.probabilityOfFailureItems, ...items];
        this.dataLoaded = true;
      }),
      catchError(error => {
        console.error('Failed to fetch items', error);
        return of([] as ProbabilityOfFailureItem[]);
      })
    );
  }

  getCachedPofItems(customerId: string): Observable<ProbabilityOfFailureItem[]> {
    if (this.cache.has(customerId)) {
      console.log('Returning data from cache for customer:', customerId);
      return of(this.cache.get(customerId)!);
    }
    return this.fetchAndCachePofItems(customerId);
  }

  private fetchAndCachePofItems(customerId: string): Observable<ProbabilityOfFailureItem[]> {
    return this.http.get<ProbabilityOfFailureItem[]>(`${this.url}/GetProbabilityOfFailureItems?customerId=${customerId}`).pipe(
      map(items => items.map(item => ({ ...item, type: 'probability' } as ProbabilityOfFailureItem))),
      map(items => items.sort((a, b) => b.order - a.order)),
      tap(items => {
        this.cache.set(customerId, items);
        this.dataLoaded = true;
      }),
      catchError(error => {
        console.error('Failed to fetch items', error);
        return of([] as ProbabilityOfFailureItem[]);
      })
    );
  }

  getProbabilityOfFailureItem(id: string): Observable<ProbabilityOfFailureItem> {
    return this.http.get<ProbabilityOfFailureItem>(this.url + `/${id}`);
  }

  postProbabilityOfFailureItem(probabilityOfFailureItem: ProbabilityOfFailureItem) {
    return this.http.post<{ id: string }>(this.url, probabilityOfFailureItem);
  }

  putProbabilityOfFailureItem(probabilityOfFailureItem: ProbabilityOfFailureItem) {
    return this.http.put(this.url, probabilityOfFailureItem);
  }

  deleteProbabilityOfFailureItem(id: string) {
    return this.http.delete<boolean>(this.url + `?id=${id}`);
  }
}
